import {
	exportButiejiaoyan,
	exportButie,
	clearButie,
	exportXianjinjiaoyan,
	exportXianjin,
	deleteButieRule,
	addRedPacketByOrg,
	addRedPacketByPerson,
	orgOperateTip,
	plEditbatchPerAccBalanceLimit,
	plEditbatchOrgAccBalanceLimit,
	getPersonInfoData,
	getAccDrawaudit,
	getAgreeDrawaudit,
	getRefuseDrawaudit
} from '@/api/account'
import { getAccenum } from '@/api/account_v3'
// import { getToken } from '@/utils/auth'
const state = {
	globalText: {
		frozenRuleEnum: '', // 冻结解冻规则
		payChannelEnum: '', // 支付渠道
		queryAccStatusEnum: '', // 账户管理-账户状态
		queryAccStatusEventEnum: '', // 账户操作记录-操作事件
		rechargePayTypeEnum: '', // 充值方式
		transferTradeTypeEnum: '', // 转账类型
		walletTypeEnum: '', // 钱包类型
		withdrawRecordStatusEnum: '', // 审批记录-审批状态
		withdrawSourceEnum: '', // 提现来源
		rechargeSourceTypeEnum: '' // 充值来源
	}
}
const mutations = {
	SAVE_GLOBALTEXT (state, data) {
		state.globalText = data
	}
}

const actions = {
	getAccenum ({ commit, rootState }, data) {
		if (!rootState.user.token) return
		return new Promise((resolve, reject) => {
			getAccenum(data)
				.then((res) => {
					Object.keys(res).forEach(v => {
						res[v] = res[v].map(({ desc, key }) => {
							return { content: desc, id: key }
						})
					})
					commit('SAVE_GLOBALTEXT', res)
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	plEditbatchOrgAccBalanceLimit ({}, data) {
		return new Promise((resolve, reject) => {
			plEditbatchOrgAccBalanceLimit(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	plEditbatchPerAccBalanceLimit ({}, data) {
		return new Promise((resolve, reject) => {
			plEditbatchPerAccBalanceLimit(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	orgOperateTip ({}, data) {
		return new Promise((resolve, reject) => {
			orgOperateTip(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addRedPacketByPerson ({}, data) {
		return new Promise((resolve, reject) => {
			addRedPacketByPerson(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	addRedPacketByOrg ({}, data) {
		return new Promise((resolve, reject) => {
			addRedPacketByOrg(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	deleteButieRule ({}, data) {
		return new Promise((resolve, reject) => {
			deleteButieRule(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportXianjinjiaoyan ({}, data) {
		return new Promise((resolve, reject) => {
			exportXianjinjiaoyan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportXianjin ({}, data) {
		return new Promise((resolve, reject) => {
			exportXianjin(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	clearButie ({}, data) {
		return new Promise((resolve, reject) => {
			clearButie(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportButie ({}, data) {
		return new Promise((resolve, reject) => {
			exportButie(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	exportButiejiaoyan ({}, data) {
		return new Promise((resolve, reject) => {
			exportButiejiaoyan(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getPersonInfoData ({}, data) {
		return new Promise((resolve, reject) => {
			getPersonInfoData(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAccDrawaudit ({}, data) {
		return new Promise((resolve, reject) => {
			getAccDrawaudit(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getAgreeDrawaudit ({}, data) {
		return new Promise((resolve, reject) => {
			getAgreeDrawaudit(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	},
	getRefuseDrawaudit ({}, data) {
		return new Promise((resolve, reject) => {
			getRefuseDrawaudit(data)
				.then((res) => {
					resolve(res)
				})
				.catch((error) => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
